import { render, staticRenderFns } from "./BuffetPage.vue?vue&type=template&id=c1714468"
import script from "./BuffetPage.vue?vue&type=script&lang=ts"
export * from "./BuffetPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports